module.exports = __webpack_public_path__ + "media/images/official/person04-826fa5ab97368f49d7f37a1141c806b8.svg";